import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import AccountDropMenu from '../../../components/templates/account-menu.vue'
//
import Utility from './../../../resources/utility'; //Utility

//
import AccountResources from './../../Account/Resources/commonfunctions.js';

let service = new services();
export default {
    name: 'Sellpoint',
    mixins: [AccountResources],
    data () {
        return {
            user:{},
            categories:{},
            market:{},
            market_groups:{},
            market_trending:{},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view:{},
            show_login:false,
            show_landing:true,
            header_data:{},
            has_shops:true,
            //
            set_view_box:'',
            set_view_box_2:'',
            set_order_options_item_index:0,
            set_product_order_options:{},
            //
            product_index:0,
            product_item_index:0,
            //
            headerComponentKey:0,
            shop_layout: 3, //default
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-sticky-header': MainHeader,
        'component-footer': MainFooter,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                }else {
                   // self.show_login=true;
                    // self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        setMarketRemote(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data; 
                    this.businesses = this.market.business_markets;
                    this.loading = false;
                //    this.getProducts();
                }
            }).catch((err) => {
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        setMarketActivities(){
            service.getMarketActivityProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_trending = response.body.data; 
                    this.products = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMarketGroups(){
            service.getMarketGroupsProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_groups = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMenuComponent(view,view_type,attr1,attr2){  
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top); 

            this.menu_view = {};
            this.menu_view[view] = true;
            
        },

        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
            })
        },

        getSellpoint(){
            this.loading = true;
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data;
                    this.header_data.name = this.sellpoint.business_name;
                    // this.header_data.componentKey++;
                    this.headerComponentKey++;
                    this.setBusinessDetails();
                    this.getSellpointProducts();
                    //props
                    this.categories = [
                        {category_name:'Swallow'},{category_name:'Drinks'},{category_name:'Swallow'},{category_name:'Drinks'},
                    ];
                    if(this.sellpoint.business_username == 'tmxmall'){
                        this.shop_layout = 3; //mall/supermarkets
                    }
                    if(this.sellpoint.business_username == 'lucas1870509088'){
                        this.shop_layout = 2; //vendors
                    }
                    if(this.sellpoint.business_username == 'jarephones'){
                        this.shop_layout = 2; //stores
                    }
                    if(this.sellpoint.business_username == 'kedi1674857669'){
                        this.shop_layout = 1; //groceries
                    }
                }
            }).catch((err) => {})
        },

        setBusinessDetails(){
            service.getBusinessByUserName(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    //setts
                    //----------delivery-locations
                    this.business_delivery_locations = this.sellpoint.business_delivery_options;
                    //----------./delivery-locations

                    //----------bank-details
                    this.business_bank_details = this.sellpoint.business_bank_details;
                    //----------./bank-details
                } 
            }).catch((err) => {})
        },
    
        getSellpointProducts(){
            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    for(let product of this.products){
                        for(let item of product.product_items){
                            item.product_name = product.product_name;
                            item.product_item_order_quantity = 1; //set as default // for oreder prep
                            item.product_order_options = product.product_information;
                            //set info state
                            for(let option of item.product_order_options){
                                option.set_status = 1; //selected//active//added
                                option.set_details = "";
                            }
                        }
                        this.set_order_addons.push(product)
                    }

                    //some setts
                    this.set_order_data.order_items = []; //ini
                    //

                    this.loading = false;
                }
            }).catch((err) => {})
        },

        
        //procs
        
        setViewBox(view){
            if(this.set_view_box == ''){
                this.setMenuTabInnerView('');
                this.toggleSingleComponent('shareBox');
            }else{
                this.setMenuTabInnerView('setOptions');
                //
                this.set_view_box = view;
            }
            
        },

        setProductView(product,product_index,product_item,product_item_index){
            this.product = product;
            this.product_index = product_index;
            //
            this.product_item = product_item;
            this.product_item_index = product_item_index;
            //
            //this.products[this.product_index].product_items[this.product_item_index].product_item_order_quantity = 1; //reset //1-default
            if(Object.keys(product).length > 0){
                this.setMenuTabInnerView('addToList');
                //this.toggleSingleComponent('productBox');
                //this.setbg();
                let self = this;
                setTimeout(function(){ 
                   self.setbg()
                }, 50); //wait for 3sec and c
            }
        },

        setProductItem(product_item,product_item_index){
            this.product_item = product_item;
            this.product_item_index = product_item_index;
            //
            //--set--at-main-end
            this.setOrderProductItem(1,product_item,this.product_index,this.product_item_index);
            //--then use here
            //this.products[this.product_index].product_items[this.product_item_index].product_item_order_quantity = 1; //reset //1-default
        },

        setProductOrderOptions(index,item,options){
            this.product_item = item;
            this.set_order_options_item_index = index;
            //this.set_product_order_options = options;
            this.set_view_box_2 = 'setProductOrderOptions';
            this.toggleSingleComponent('infoBox');
        },
        //../procs

        //
        setbg(){
            this.componentKey++;
            //dbgg
            let el = document.getElementById('dbgg');
            let el_width = el.offsetWidth;
            let el_height = el.offsetHeight;
            let bg_width = 50;
            let bg_height = 50;
            let ibg =  (el_width-bg_width+10) + "px " + (el_height-bg_height-10) +  "px";
            //dxmg
            let xel = document.getElementById('xmg');
            let xel_width = xel.offsetWidth;
            let xel_height = xel.offsetHeight;
            //
            console.log(xel)
            let rf = false;
            if((xel_height - xel_width) > 40){
                console.log('ovvff---'+(xel_height - xel_width));
                rf = true;
            }
            //
            if(rf){
                el.style.backgroundPosition = 'center';
                el.style.height = '50vh';
            }else{
               console.log('op00ttt'); 
               el.style.height = xel_height+'px';
               //el.style.backgroundPosition = ibg;
            }
            console.log('op2200--win'+window.innerWidth+'---el-width'+el_width); 
            // if((window.innerWidth - el_width) > 5){
            //     // console.log('op00'); 
            //     console.log(window.innerWidth - el_width)
            //     el.style.backgroundPosition = ibg;
            // }else{
            //     el.style.backgroundPosition = 'center';
            //       console.log('op00'); 
            //      console.log(window.innerWidth - el_width)
            // }
            //
            document.getElementById('xmg').style.display = 'none';
           // document.getElementById('xmg').remove;
        }
    },
    created: function(){
        if(localStorage.getItem('appOn')){
            this.show_landing = false;
        }else{
            //
            localStorage.setItem('appOn',1); //check best unset later //use time count
        }
        this.menu_view["timeline"] = true;
        this.preset();
        this.getSellpoint();
        //
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/Sellpoint/Sellpoint/script.js